import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import API from '../../../../API';
import $ from 'jquery';
import { cardToken } from '../../../../reducers/feed/feed.actions';
import { useDispatch, useSelector } from 'react-redux';
import { VisaIcon, MastercardIcon, AmexIcon, DinerIcon, DiscoverIcon, JsbIcon } from '../../../../components/Icons';

const Cards = ({ cardName }) => {


    const CardSwitch = () => {
        switch (cardName) {
            case 'VISA': return (

                <VisaIcon />

            )

            case 'MASTERCARD': return (

                <MastercardIcon />

            )

            case 'AMEX': return (

                <AmexIcon />

            )
            case 'DINERS': return (

                <DinerIcon />

            )

            case 'DISCOVER': return (

                <DiscoverIcon />

            )
            case 'JCB': return (

                <JsbIcon />

            )
                return true;
            default:
                return false;
        }
    }
    return (
        <div>
            {CardSwitch()}
        </div>
    );
};

export default Cards;
